import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ModalInfoType } from '@components/molecules/modal/Modal'

import type { InquiryStateType } from '@redux/types'

// initial state
const initialState: InquiryStateType = {
	triggerInitInquiryPage: false,
	triggerSendInquiry: false,

	showModal: false,
	modalInfo: {
		target: '',
		title: '',
	},

	insertInquiry: {
		name: '',
		email: '',
		categ: '',
		message: '',
	},
	inquiryErrorMessage: {
		name: '',
		email: '',
		categ: '',
		message: '',
	},
}

const slice = createSlice({
	name: 'inquiry',
	initialState,
	reducers: {
		TRIGGER_INIT_INQUIRY_PAGE: (
			state: InquiryStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitInquiryPage = action.payload
		},
		TRIGGER_SEND_INQUIRY: (state: InquiryStateType, action: PayloadAction<boolean>) => {
			state.triggerSendInquiry = action.payload
		},

		SHOW_MODAL: (state: InquiryStateType, action: PayloadAction<boolean>) => {
			state.showModal = action.payload
		},
		MODAL_INFO: (state: InquiryStateType, action: PayloadAction<ModalInfoType>) => {
			state.modalInfo = action.payload
		},

		INSERT_INQUIRY: (
			state: InquiryStateType,
			action: PayloadAction<InquiryStateType['insertInquiry']>,
		) => {
			state.insertInquiry = action.payload
		},
		INQUIRY_ERROR_MESSAGE: (
			state: InquiryStateType,
			action: PayloadAction<InquiryStateType['inquiryErrorMessage']>,
		) => {
			state.inquiryErrorMessage = action.payload
		},
	},
})

export const inquiryActions = slice.actions
export default slice.reducer
